import React from 'react';

import Data from 'data';
import Store from 'store';
import Locale from 'data/locale';

const _L = Locale("ui-stats.js");

function exportProfile(profile) {
  const lines = [];
  const sections = [Data.classes[profile.class].name];

  const skL = Locale("ui-skills.js");
  const eqL = Locale("ui-equipment.js");

  const slotNames = [_L`LMB`, _L`RMB`, "1", "2", "3", "4"];
  const noRune = skL`No rune`;
  for (let slot = 0; slot < profile.skills.length; ++slot) {
    const skill = profile.skills[slot];
    const info = skill && Data.skills[profile.class][skill[0]];
    if (skill && info) {
      lines.push(`${slotNames[slot]},${info.name},${skill[1] === "x" ? noRune : info.runes[skill[1]]}`);
    }
  }
  if (lines.length) {
    sections.push(lines.join("\n"));
    lines.length = 0;
  }

  for (let slot = 0; slot < profile.passives.length; ++slot) {
    const skill = profile.passives[slot];
    const info = skill && Data.passives[profile.class][skill];
    if (skill && info) {
      lines.push(info.name);
    }
  }
  if (lines.length) {
    sections.push(lines.join("\n"));
    lines.length = 0;
  }

  for (const slot in profile.items) {
    const data = [Data.itemSlots[slot].name];
    const item = profile.items[slot];
    const info = item && Data.itemById[item.id];
    if (!item || !info) {
      data.push(eqL`Empty slot`);
    } else {
      data.push(info.name);
      data.push(item.ancient ? (item.ancient === "primal" ? eqL`Primal Ancient` : eqL`Ancient`) : "");
      for (const stat in item.stats) {
        let name = Data.stats[stat]?.name;
        if (stat === "custom" && info.required?.custom) {
          if (info.required.custom.options) {
            name = Data.itemById[item.customId || info.required.custom.options[0]]?.required?.custom?.name;
          } else {
            name = info.required.custom.name;
          }
        }
        if (name) {
          data.push(item.stats[stat].join("-") + " " + name);
        }
      }
    }
    lines.push(data.join(","));
    if (item && item.gems) {
      for (const gem of item.gems) {
        if (!gem || !(gem instanceof Array)) continue;
        const leg = Data.legendaryGems[gem[0]];
        const reg = Data.gemColors[gem[1]];
        if (leg) lines.push(`,${leg.name},${gem[1]}`);
        else if (reg) lines.push(`,${reg.names[gem[0]]}`);
      }
    }
  }
  if (lines.length) {
    sections.push(lines.join("\n"));
    lines.length = 0;
  }

  for (const id in profile.kanai) {
    const iid = profile.kanai[id];
    const item = iid && Data.itemById[iid];
    if (item) lines.push(item.name);
  }
  if (lines.length) {
    lines.unshift(skL`Kanai's Cube`);
    sections.push(lines.join("\n"));
    lines.length = 0;
  }

  return sections.join("\n\n");
}

export default React.memo(function ExportLine() {
  const profile = Store.useProfile();
  const onExport = React.useCallback(() => {
    const text = exportProfile(profile);
    const url = window.URL.createObjectURL(new Blob([text], {type: "text/csv"}));
    const exportElement = document.createElement("a");
    exportElement.href = url;
    exportElement.download = "profile.csv";
    document.body.appendChild(exportElement);
    exportElement.click();
    setTimeout(function() {
      document.body.removeChild(exportElement);
      window.URL.revokeObjectURL(url);
    }, 100);
  }, [profile]);
  return <li><span className="d3p-export" onClick={onExport}>{_L`Export CSV`}</span></li>;
});
